import { Link } from 'react-router-dom';
import { FiArrowRight, FiMail } from 'react-icons/fi';
import Reveal from '../ui/Reveal';

export default function CTASection() {
  return (
    <section id="contact" className="scroll-mt-24 py-24">
      <div className="container-page">
        <Reveal className="relative overflow-hidden rounded-3xl bg-brand-gradient px-8 py-16 text-center text-white sm:px-16">
          <div className="pointer-events-none absolute -right-10 -top-10 h-56 w-56 rounded-full bg-white/10 blur-2xl" />
          <div className="pointer-events-none absolute -bottom-12 -left-12 h-64 w-64 rounded-full bg-white/10 blur-2xl" />

          <div className="relative flex flex-col items-center gap-6">
            <h2 className="max-w-2xl text-3xl font-bold tracking-tight sm:text-4xl">
              Piua AI is ready when you are
            </h2>
            <p className="max-w-xl text-base text-white/85">
              Create an account, pick the plan that fits how you work, and start chatting in minutes — knowing your
              details never leave the conversation.
            </p>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Link
                to="/signup"
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-white px-6 py-3 text-sm font-semibold text-brand-700 shadow-card transition hover:-translate-y-0.5"
              >
                Create your account <FiArrowRight />
              </Link>
              <a
                href="mailto:feedback@victrie.com"
                className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/40 px-6 py-3 text-sm font-semibold text-white transition hover:bg-white/10"
              >
                <FiMail /> Have a question?
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
